<i18n>
{
  "cl": {
    "getFeaturesErrorMessage": "Ocurrió un error al tratar de obtener los permisos para asignar",
    "setFeaturesErrorMessage": "Ocurrió un error al tratar de modificar el permiso",
    "activateFeaturesErrorMessage": "Ocurrió un error al tratar de activar los permisos",
    "lengthFeaturesErrorMessage": "Debes configurar al menos una característica",
    "setFeaturesActivatedMessage": "Los permisos fueron activados exitosamente",
    "activated": "Activadas",
    "deactivated": "Desactivadas",
    "notConfigured": "No configuradas",
    "path": "Rutas",
    "filter": "Filtrar",
    "return": "Volver",
    "role": "Rol",
    "userPermissions": "Permisos de usuario de ",
    "permissions": "Usted no tiene permisos para ejecutar este menú",
    "activate": "Activar",
    "activateAll": "Activar todos",
    "desactiveAll": "Desactivar Todos",
    "config": "Configurar",
    "read": "Lectura",
    "write": "Escritura",
    "without": "Ninguna",
    "selectSection": "Selecciona una sección",
    "serverError": "Ocurrió un error de comunicación con el servidor.",
    "confirmDeleteUser": "¿Seguro quieres eliminar el usuario?"
  },
  "pe": {
    "getFeaturesErrorMessage": "Ocurrió un error al tratar de obtener los permisos para asignar",
    "setFeaturesErrorMessage": "Ocurrió un error al tratar de modificar el permiso",
    "activateFeaturesErrorMessage": "Ocurrió un error al tratar de activar los permisos",
    "lengthFeaturesErrorMessage": "Debes configurar al menos una característica",
    "setFeaturesActivatedMessage": "Los permisos fueron activados exitosamente",
    "activated": "Activadas",
    "deactivated": "Desactivadas",
    "notConfigured": "No configuradas",
    "path": "Rutas",
    "filter": "Filtrar",
    "return": "Volver",
    "role": "Rol",
    "userPermissions": "Permisos de usuario de ",
    "permissions": "Usted no tiene permisos para ejecutar este menú",
    "activate": "Activar",
    "activateAll": "Activar todos",
    "desactiveAll": "Desactivar Todos",
    "config": "Configurar",
    "read": "Lectura",
    "write": "Escritura",
    "without": "Ninguna",
    "selectSection": "Selecciona una sección",
    "confirmDeleteUser": "¿Seguro quieres eliminar el usuario?"
  },
  "br": {
    "getFeaturesErrorMessage": "Ocorreu um erro ao obter permissões para atribuir",
    "setFeaturesErrorMessage": "Ocorreu um erro ao tentar modificar a permissão",
    "activateFeaturesErrorMessage": "Ocorreu um erro ao tentar ativar as permissões",
    "lengthFeaturesErrorMessage": "Você deve configurar pelo menos um recurso",
    "setFeaturesActivatedMessage": "As permissões foram ativadas com sucesso",
    "activated": "Ativadas",
    "deactivated": "Desativadas",
    "notConfigured": "Não configuradas",
    "path": "Rotas",
    "filter": "Filtro",
    "return": "Retornar",
    "role": "Função",
    "userPermissions": "Permissões de usuário de",
    "permissions": "Você não tem permissão para executar este menu",
    "activate": "Ativar",
    "activateAll": "ativar tudo",
    "desactiveAll": "desabilitar tudo",
    "config": "Configurar",
    "read": "Leitura",
    "write": "Escrita",
    "without": "nenhum",
    "selectSection": "Selecione uma seção",
    "serverError": "Ocorreu um erro de comunicação com o servidor.",
    "confirmDeleteUser": "¿Seguro quieres eliminar el usuario?"
  }
}
</i18n>
<template>
  <div class="feature card-item">
    <div v-if="!checkUserFeature('nav.settings.users-permissions')" id="notPermissions">
      <p>{{ $t('permissions') }}</p>
    </div>
    <div v-else>
      <Spinner id="spinner" :is-loading="isLoading" />
      <div v-if="!isLoading" id="search-container" class="feature card-item">
        <div v-if="showList">
          <div class="mt-4 pb-4">
            <b-taginput
              id="filter-input"
              v-model="userFilters"
              rounded
              class="taginput"
              size="is-small"
              :data="filteredUsersTagsList"
              autocomplete
              :allow-new="true"
              :open-on-focus="true"
              field="feature.name"
              :placeholder="$t('filter')"
              close-type="is-success"
              @typing="finderUsers" />
          </div>
          <div
            v-for="(user, i) in findedUsers"
            :key="i"
            class="feature user-item card-item shadowless">
            <div class="user-item-info clearfix">
              <div class="text-info">
                <div v-if="user.userFeaturesConfig && user.userFeaturesActive" :id="`activate-user-${user._id}`" class="tag is-medium is-success is-light">{{ $t('activated') }}</div>
                <div v-if="user.userFeaturesConfig && !user.userFeaturesActive" :id="`deactivate-user-${user._id}`" class="tag is-medium is-info is-light">{{ $t('deactivated') }}</div>
                <div v-if="!user.userFeaturesConfig" class="tag is-medium is-danger is-light">{{ $t('notConfigured') }}</div>
                <div class="text has-text-weight-bold title-label">{{ user.name || 'N/A' }}</div>
                <div><span class="text">{{ user.email }}</span></div>
                <div><span class="text">{{ $t('role') }}: {{ user.rol || 'N/A' }}</span></div>
                <div>
                  <b-tooltip
                    size="is-medium"
                    multilined
                    position="is-top">
                    <template #content>
                      <p class="tootip-title">{{ $t('path') }}</p>
                      <span>{{ user.allowedFrontRoutesNames ? user.allowedFrontRoutesNames.join(', ') : 'N/A' }}</span>
                    </template>
                    <i class="fa-solid fa-location-dot" />
                  </b-tooltip>
                </div>
                <div>
                  <b-button
                    v-if="(user.userFeaturesConfig && !user.userFeaturesActive)"
                    :id="`activate-button-${user._id}`"
                    class="button is-button-primary is-rounded"
                    @click="activeUser(user)">
                    <span>
                      {{ $t('activate') }}
                    </span>
                  </b-button>
                </div>
                <div>
                  <button
                    :id="`user-${user._id}`"
                    class="button is-button-secondary is-rounded"
                    @click="clickedOnUser(user)">
                    <span>
                      {{ $t('config') }}
                    </span>
                  </button>
                </div>
                <div>
                  <a
                    v-if="checkUserFeature('element.settings.user.button.delete')"
                    :id="`delete-button-${user._id}`"
                    @click="setConfirmDelete(user._id)">
                    <span :disablerd="true" class="fa-solid fa-trash fa-x2" />
                  </a>
                </div>
              </div>
              <div v-if="confirmDelete === user._id" class="delete-info">
                <p class="is-text">
                  {{ $t('confirmDeleteUser') }}
                </p>
                <b-button
                  :id="`confirm-delete-button-${user._id}`"
                  class="is-button-primary is-small is-rounded"
                  @click="deleteUser(user);setConfirmDelete('')">
                  <span>
                    Si
                  </span>
                </b-button>
                <b-button
                  id="ask-button"
                  class="is-text"
                  @click="setConfirmDelete('')">
                  <span>
                    No
                  </span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!showList && selectedUser" id="features-container">
          <div>
            <b-button
              v-if="!showList"
              id="back-button"
              class="is-button-primary ml-2 mt-1 is-small is-rounded is-pulled-right"
              @click="() => goBack()">
              <span>
                {{ $t('return') }}
              </span>
            </b-button>
          </div>
          <div class="default-client-header">
            <div class="header-name">
              <h3>
                {{ `${$t('userPermissions')} ${selectedUser.name || ''} ${selectedUser.lastName || ''}` }}
              </h3>
            </div>
          </div>

          <div>
            <div class="mt-3">
              <b-field expanded>
                <div class="column is-flex is-vcentered pl-0 pb-0">
                  <b-field>
                    <b-select
                      id="select-section"
                      v-model="selectedSectionName"
                      :placeholder="$t('selectSection')"
                      size="is-small"
                      rounded>
                      <option
                        v-for="(sectionName, i) in [$t('without')].concat(sections.map(section => section.name))"
                        id="cobranza"
                        :key="i"
                        :value="sectionName">
                        {{ sectionName }}
                      </option>
                    </b-select>
                  </b-field>
                  <b-field class="is-flex is-vcentered ml-3">
                    <b-checkbox
                      v-model="selectedSectionMode"
                      :disabled="!selectedSection"
                      size="is-small"
                      native-value="read">
                      {{ $t('read') }}
                    </b-checkbox>
                    <b-checkbox
                      v-model="selectedSectionMode"
                      :disabled="!selectedSection"
                      size="is-small"
                      native-value="write">
                      {{ $t('write') }}
                    </b-checkbox>
                  </b-field>
                </div>
                <div class="column pb-0">
                  <div :class="userIdsByCOuntry.cl ? '' : 'img-gray'">
                    <img class="fas fa-2 is-pulled-right mt-2 mr-2" src="@/ui/assets/img/chile.png">
                  </div>
                  <div :class="userIdsByCOuntry.br ? '' : 'img-gray'">
                    <img class="fas fa-2 is-pulled-right mt-2 mr-2" src="@/ui/assets/img/brasil.png">
                  </div>
                  <div :class="userIdsByCOuntry.pe ? '' : 'img-gray'">
                    <img class="fas fa-2 is-pulled-right mt-2 mr-2" src="@/ui/assets/img/peru.png">
                  </div>
                  <b-field class="is-flex is-vcentered check is-pulled-right mr-2">
                    <p class="is-size-7 mt-1 mr-2"> clonar </p>
                    <b-switch
                      id="clone-features"
                      v-model="switchCloneAll"
                      :disabled="!(userIdsByCOuntry.cl || userIdsByCOuntry.br || userIdsByCOuntry.pe)"
                      type="is-success"
                      @input="cloneAllFeatures()" />
                  </b-field>
                </div>
                <div class="column pb-0">
                  <b-field class="is-flex is-vcentered check is-pulled-right mr-2">
                    <p class="is-size-7 mt-1 mr-2">{{ switchAllowAll ? $t('desactiveAll'): $t('activateAll') }}</p>
                    <b-switch
                      id="set-all-features"
                      v-model="switchAllowAll"
                      type="is-success"
                      @input="setAllowAllFeatures()" />
                  </b-field>
                </div>
              </b-field>
            </div>
          </div>
          <div class="mt-4 pb-4">
            <b-taginput
              id="filter-input"
              v-model="filters"
              rounded
              :data="filteredTags"
              autocomplete
              :before-adding="beforeAdding"
              :allow-new="true"
              :open-on-focus="true"
              field="feature.name22"
              :placeholder="$t('filter')"
              close-type="is-success"
              @typing="getFilteredTags" />
          </div>
          <div
            v-for="feature in filteredUserFeaturesMap"
            :id="`feature-${feature.name}`"
            :key="feature.name"
            class="feature card-item shadowless">
            <div class="feature-body">
              <b-field class="check is-pulled-right">
                <b-switch
                  :id="`switch-${feature.name}-${feature.allowed}`"
                  v-model="feature.allowed"
                  type="is-success"
                  @input="updateFeaturePermission(feature.name)" />
              </b-field>
              <h3>{{ feature.description }}</h3>
              <p>{{ feature.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { findBackOfficeUsers, getAllUserFeatures, getAllUserFeatureSections, deleteUser,
  setUserFeature, findUserIdsByEmailOnAllCountries, setUserFeatures, activateUserFeatures, cloneUserFeatures } from '@/application/services/api-clients/users';
import Spinner from '@/ui/components/Spinner.vue';
import notification from '@/ui/mixins/notification';
import userFeatures from '@/ui/mixins/user-features';

export default {
  name: 'UsersPermissions',
  components: { Spinner },
  mixins: [notification, userFeatures],
  props: {
    restart: { type: Boolean, default: true }
  },
  data() {
    return {
      confirmDelete: false,
      userIdsByCOuntry: { cl: '', br: '', pe: '' },
      toast: this.$buefy.toast,
      switchCloneAll: false,
      switchAllowAll: false,
      selectedSectionMode: [],
      selectedSection: '',
      selectedSectionName: null,
      sections: [],
      allowedFrontRoutesNames: [],
      extendedOptions: true,
      isExtended: false,
      showList: true,
      isLoading: false,
      isSelectOnly: false,
      filters: undefined, // aqui se guardan los tags
      userFilters: [],
      allowNew: false,
      openOnFocus: false,
      selectedUser: undefined,
      errorMessages: {
        getFeatures: '',
        setFeatures: '',
        activeUsers: ''
      },
      userFeatures: [],
      tagsList: [],
      usersTagsList: [],
      filteredUsersTagsList: [],
      userFeaturesMap: [],
      filteredUserFeaturesMap: [],
      filteredTags: [],
      users: [],
      findedUsers: [],
      finder: this.finderUsers,
      cleaner: this.cleanerUsers
    };
  },
  watch: {
    switchCloneAll: {
      immediate: true,
      deep: true,
      handler() {
        this.switchCloneAll = false;
      }
    },
    restart: {
      immediate: true,
      deep: true,
      handler() {
        this.init();
      }
    },
    selectedSectionName: {
      immediate: true,
      deep: true,
      handler() {
        this.selectedSection = this.sections.find(section => section.name === this.selectedSectionName);
        if (this.selectedSection) this.selectedSectionMode = ['read'];
        else this.selectedSectionMode = [];
        this.applyFilters();
      }
    },
    selectedSectionMode: {
      immediate: true,
      deep: true,
      handler() {
        this.applyFilters();
      }
    },
    filters: {
      immediate: true,
      deep: true,
      handler() {
        this.applyFilters();
      }
    },
    userFilters: {
      immediate: true,
      deep: true,
      handler() {
        this.finderUsers();
      }
    },
    selectedUser: {
      immediate: true,
      deep: true,
      handler() {
        this.changeUserFeaturesMap();
      }
    }
  },

  async mounted() {
    await this.getUsers();
    await this.init();
  },
  methods: {
    setConfirmDelete(id) {
      this.confirmDelete = id;
    },
    async deleteUser(user) {
      try {
        await deleteUser(user);
        this.users = this.users.filter(usr => usr._id !== user._id);
        this.cleanerUsers();
        this.showInfo('Borrado exitoso');
      } catch (_err) {
        this.showError();
      }
    },
    async init() {
      this.isLoading = true;
      await this.getFeatures();
      await this.getSections();
      this.isLoading = false;
    },
    showError() {
      this.toast.open({
        position: 'is-top-right',
        message: this.$t('serverError'),
        type: 'is-danger',
        duration: 5000
      });
    },
    showInfo(message) {
      this.toast.open({
        position: 'is-top-right',
        message,
        type: 'is-info',
        duration: 3000
      });
    },
    async cloneAllFeatures() {
      if (this.switchCloneAll) {
        const userFeaturesToBackend = this.userFeaturesMap.map(feature => ({ name: feature.name, status: feature.allowed }));
        try {
          await cloneUserFeatures(this.userIdsByCOuntry, userFeaturesToBackend);
          this.showInfo('Clonación exitosa');
        } catch (_err) {
          this.showError();
        }
      }
      this.switchCloneAll = false;
    },
    async setAllowAllFeatures() {
      this.filteredUserFeaturesMap.forEach(feature => {
        // eslint-disable-next-line no-param-reassign
        feature.allowed = this.switchAllowAll;
      });
      const userFeaturesToBackend = this.filteredUserFeaturesMap.map(feature => ({ name: feature.name, status: feature.allowed }));
      try {
        await setUserFeatures(this.selectedUser._id, userFeaturesToBackend);
      } catch (_error) {
        this.errorMessages.setFeatures = this.$t('setFeaturesErrorMessage');
        this.alert({
          message: this.errorMessages.setFeatures,
          alertType: 'is-danger'
        });
      }
    },
    async getSections() {
      try {
        this.sections = await getAllUserFeatureSections();
      } catch (_error) {
        this.errorMessages.getFeatures = this.$t('serverError');
        this.alert({
          message: this.errorMessages.getFeatures,
          alertType: 'is-danger'
        });
      }
    },
    cleanerUsers() {
      this.findedUsers = this.users;
    },
    setUserTags() {
      const rols = Array.from(new Set(this.users.map(user => user.rol))).filter(rol => !!rol);
      const states = [this.$t('activated'), this.$t('deactivated'), this.$t('notConfigured')];
      this.usersTagsList = states.concat(rols);
      this.filteredUsersTagsList = this.usersTagsList;
      this.userFilters = [];
    },
    finderUsers(searchString = '') {
      this.filteredUsersTagsList = this.usersTagsList.filter(tag => tag.toLowerCase().includes(searchString.toLowerCase()));

      if (!this.userFilters || this.userFilters.length === 0) {
        return this.cleanerUsers();
      }
      this.findedUsers = this.users.filter(user => {
        const sameName = this.userFilters && user.name && this.compareArrays(this.userFilters, user.name);
        const sameEmail = this.userFilters && user.email && this.compareArrays(this.userFilters, user.email);
        const sameRol = this.userFilters && user.rol && this.compareArrays(this.userFilters, user.rol);

        let userState;
        if (user.userFeaturesConfig && user.userFeaturesActive) userState = this.$t('activated');
        else if (user.userFeaturesConfig && !user.userFeaturesActive) userState = this.$t('deactivated');
        else userState = this.$t('notConfigured');

        const sameState = this.userFilters && this.userFilters.some(filter => filter === userState);
        return sameName || sameEmail || sameRol || sameState;
      });
      return this.findedUsers;
    },

    clientUserFeaturesFilters() {
      this.filters = [];
      this.selectedSectionName = null;
    },
    async goBack() {
      this.isLoading = true;
      this.clientUserFeaturesFilters();
      this.showList = !this.showList;
      await this.getUsers();
      this.isLoading = false;
    },
    async getUsers() {
      const users = await findBackOfficeUsers();
      this.users = users.map(user => {
        // eslint-disable-next-line no-param-reassign
        user.userFeaturesConfig = (user.allowedUserFeatures || []).length > 0;
        // eslint-disable-next-line no-param-reassign
        user.userFeaturesActive = user.userFeaturesConfig && !user.allowedFrontRoutesNames && !user.rol;
        return user;
      }).sort(a => (a.userFeaturesActive || a.userFeaturesConfig ? -1 : 1))
        .sort(a => (a.userFeaturesActive ? -1 : 1));
      this.cleanerUsers();
      this.setUserTags();
    },
    beforeAdding(tag) {
      if (tag.includes(',')) {
        const newFilters = tag.split(',').map(v => v.replace(/['"]+/g, '').trim()).filter(v => v);
        const SetFilters = Array.from(new Set(this.filters ? this.filters.concat(newFilters) : newFilters));
        this.filters = SetFilters;
        return false;
      }
      return true;
    },
    getFilteredTags(text) {
      this.filteredTags = this.tagsList.filter(tag => tag.toString().toLowerCase().includes(text.toLowerCase()));
    },
    applyFilters() {
      const noFeatureFilter = !this.filters || this.filters.length === 0;
      // Si se seleccionó sección, pero no un modo, no muestro permisos
      if (this.selectedSection && !this.selectedSectionMode.length) {
        this.filteredUserFeaturesMap = [];
        this.setTagList(this.filteredUserFeaturesMap);
        return;
      }

      // Si no hay sección cargo todos los permisos
      if (!this.selectedSection) {
        this.filteredUserFeaturesMap = this.userFeaturesMap;
        this.setTagList(this.filteredUserFeaturesMap);
        if (noFeatureFilter) return; // Si no hay filtro no sigo
      }

      // Si hay sección y modo, muestro los permisos del modo
      if (this.selectedSection && this.selectedSectionMode.length) {
        let userFeatureIds = [];
        this.selectedSectionMode.forEach(mode => {
          userFeatureIds = userFeatureIds.concat(this.selectedSection[mode]);
        });
        this.filteredUserFeaturesMap = this.userFeaturesMap.filter(feature => userFeatureIds.includes(feature._id));
      }

      // si hay filtros, los aplico sobre los permisos ya listados.
      if (!noFeatureFilter) {
        const filteredUserFeaturesMap = this.filteredUserFeaturesMap.filter(feature => {
          const isName = this.compareArrays(this.filters, feature.name);
          const isTag = this.compareArrays(this.filters, feature.tags);
          const isDescription = this.compareArrays(this.filters, feature.description);
          return isName || isTag || isDescription;
        });
        this.filteredUserFeaturesMap = filteredUserFeaturesMap;
      }

      this.setTagList(this.filteredUserFeaturesMap);
      this.sortFeatures();
    },
    sortFeatures() {
      const sorFeaturesByName = (a, b) => {
        const map = { nav: 1, endpoint: 3, element: 2 };
        return map[a.name.split('.')[0]] - map[b.name.split('.')[0]];
      };
      if (this.filteredUserFeaturesMap.length) {
        const allowedFeatures = this.filteredUserFeaturesMap
          .filter(feature => feature.allowed)
          .sort(sorFeaturesByName);
        const notAllowedFeatures = this.filteredUserFeaturesMap
          .filter(feature => !feature.allowed)
          .sort(sorFeaturesByName);
        this.filteredUserFeaturesMap = allowedFeatures.concat(notAllowedFeatures);
      }
    },
    compareArrays(arrayOne, arrayTwo) {
      // eslint-disable-next-line no-param-reassign
      if (typeof arrayTwo === 'string') arrayTwo = arrayTwo.toLowerCase();
      // eslint-disable-next-line no-param-reassign
      else if (Array.isArray(arrayTwo)) arrayTwo = arrayTwo.map(element => element.toLowerCase());
      return arrayOne.some(elementOne => arrayTwo.includes(elementOne.toLowerCase()));
    },
    setTagList(userFeaturesIn) {
      const featuresArray = userFeaturesIn.reduce((acc, feature) => acc.concat(feature.tags), []);
      const settedFeaturesArray = new Set(featuresArray);
      this.tagsList = Array.from(settedFeaturesArray);
      this.filteredTags = this.tagsList;
    },
    async getFeatures() {
      try {
        this.userFeatures = await getAllUserFeatures();
        this.setTagList(this.userFeatures);
      } catch (_error) {
        this.errorMessages.getFeatures = this.$t('getFeaturesErrorMessage');
      }
    },
    async clickedOnUser(user) {
      const { email } = user;
      this.userIdsByCOuntry = await findUserIdsByEmailOnAllCountries(email);
      this.filteredUserFeaturesMap = [];
      this.selectedUser = user;
      this.showList = false;
    },
    async activeUser(user) {
      this.isLoading = true;
      try {
        await activateUserFeatures(user._id);
        this.alert({ message: this.$t('setFeaturesActivatedMessage'), alertType: 'is-primary' });
        await this.getUsers();
      } catch (_error) {
        this.errorMessages.activeUsers = this.$t('activateFeaturesErrorMessage');
        this.alert({ message: this.errorMessages.activeUsers, alertType: 'is-danger' });
      }
      this.isLoading = false;
    },
    async updateFeaturePermission(featureName) {
      let setting = false;
      const foundFeatureName = this.filteredUserFeaturesMap.find(feature => feature.name === featureName);
      if (foundFeatureName) {
        setting = foundFeatureName.allowed;
      }
      try {
        await setUserFeature(this.selectedUser._id, featureName, setting);
      } catch (_error) {
        this.errorMessages.setFeatures = this.$t('setFeaturesErrorMessage');
        this.alert({ message: this.errorMessages.setFeatures, alertType: 'is-danger' });
      }
    },
    changeUserFeaturesMap() {
      this.userFeaturesMap = this.userFeatures.map(userFeature => {
        const newUserFeature = userFeature;
        let foundUserFeatures = false;
        if (this.selectedUser) {
          if (this.selectedUser.allowedUserFeatures) {
            foundUserFeatures = this.selectedUser.allowedUserFeatures.includes(userFeature.name);
          }
        }
        newUserFeature.allowed = foundUserFeatures;
        return newUserFeature;
      });
      this.applyFilters();
    }
  }
};
</script>

<style scoped>
img {
  width: 20px;
}

h3 {
  padding: 0;
  margin: 0;
}

#activate-button {
  width: 100px;
}

.img-gray {
  filter: grayscale(100%);
}

.user-item {
  overflow: inherit;
}

.fa-location-dot {
  color: #00CCD1;
}

.tootip-title {
  font-weight: bold;
}

.check {
  margin-top: 0.331rem;
}

.feature {
  margin-bottom: 1.1rem;
  display: block;
  overflow: visible;
}

.feature:last-child {
  margin-bottom: 0;
}

.text-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
}

.delete-info {
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 250px 50px 50px ;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  gap: 1rem;
}

.text {
  width: 5rem;
}

.default-client-header {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
  gap: 0rem 1rem;
  place-items: center;
  color: var(--primary);
  font-weight: 600;
}

.default-client-header .header-name {
  justify-self: start;
}

.default-client-header .button {
  justify-self: end;
}

@media (max-width: 1370px){
  .text-info{
    display: block;
    text-align: center;
  }
  .tag {
    margin: 0px auto;
  }
  .text {
    margin: 0px auto;
  }
  .button{
    margin-top: 10px;
  }
}

</style>
